//react-components
import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

//Styles
import "./ChangePassword.scss";

//Strings
import { Strings } from "../Translations/i18n";

export default class ChangePassword extends Component {
  constructor() {
    super();
    this.state = {
      oldPassword: "",
      errorMessage: "",
      password: "",
      confirmPassword: "",
    };
  }

  onChange = (event) => {
    this.setState({
      errorMessage: "",
      [event.target.name]: event.target.value,
    });
  };

  /**
   * Validate password values
   */
  validatePasswordDetails = () => {
    let error = true;
    let errorMessage = "";
    if (
      !this.state.password ||
      !this.state.oldPassword ||
      !this.state.confirmPassword
    ) {
      error = false;
      errorMessage = Strings("errorEmptyFields");
    } else if (this.state.password !== this.state.confirmPassword) {
      error = false;
      errorMessage = Strings("errorNewPasswordAndConfirmPasswordAreNotSame");
    } else if (this.state.password === this.state.oldPassword) {
      error = false;
      errorMessage = Strings("oldPasswordSameAsNew");
    }
    this.setState({
      errorMessage: errorMessage,
    });
    return error;
  };

  /**
   *Handle Submit by passing username and password
   */
  handlePasswordChange = () => {
    if (this.validatePasswordDetails()) {
      this.props.handleChangePasswordSubmit(
        this.state.oldPassword,
        this.state.password
      );
    }
  };

  render() {
    return (
      <Col md={5} className="changePasswordPanel">
        <Row className="changePasswordTitle">{Strings("changePassword")}</Row>
        <Row className="mainPanel">
          <div className="errors heightMaxContent">
            {this.state.errorMessage === ""
              ? this.props.errorMessage
              : this.state.errorMessage}
          </div>
          <Form.Control
            id="oldPassword"
            type="password"
            placeholder="Contraseña Anterior"
            onChange={this.onChange}
            name={"oldPassword"}
          />
          <Form.Control
            id="username"
            type="password"
            placeholder="Nueva Contraseña"
            onChange={this.onChange}
            name={"password"}
          />
          <Form.Control
            id="password"
            type="password"
            placeholder="Confirmar La Contraseña"
            onChange={this.onChange}
            name={"confirmPassword"}
          />
        </Row>
        <hr className="horizontalLine" />
        <div>
          <div>
            <Button
              variant=""
              className="loginButton buttonBackground pull-right mx-1"
              onClick={this.handlePasswordChange}
            >
              {Strings("submit")}
            </Button>
          </div>

          <div>
            {" "}
            <Button
              variant=""
              className="buttonBorder pull-right extraMarginRight mx-1"
              onClick={this.props.goToPreviousPage}
            >
              {Strings("cancel")}
            </Button>
          </div>
        </div>
      </Col>
    );
  }
}
